/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    
    import IReportControl = Meevo.Model.IReportControl;

    interface FilterItemType {
        displayName: string,
        itemType: Model.SalesTypeEnum,
        template: string,
        placeholder: string
    }

    class MeevoServiceProductSelector implements angular.IComponentController {

        public mainModel: Object;
        public parameterNames: string[];
        public securityAccess: any;
        public options: IReportControl;

        public filterItemTypes: FilterItemType[] = [{
            displayName: 'LABEL_SERVICE',
            itemType: Meevo.Model.SalesTypeEnum.Service,
            template: 'service',
            placeholder: 'LABEL_SEARCH_FOR_SERVICE_PLACEHOLDER'
        }, {
            displayName: 'LABEL_PRODUCT',
            itemType: Meevo.Model.SalesTypeEnum.Product,
            template: 'productvariant',
            placeholder: 'LABEL_SEARCH_FOR_PRODUCT_PLACEHOLDER'
        }];
        public filterItemCriteria = {
            includeActive: true,
            includeInactive: true,
            IncludeDeleted: true
        }
        public selectedFilterItemType: FilterItemType;
        public selectedFilterItem: any;
        public selectedList: any[] = [];

        public initializeTypeAhead: boolean;


        $onInit() {
            this.mainModel[this.parameterNames[0]] = false;
            this.mainModel[this.parameterNames[1]] = Meevo.Model.SalesTypeEnum.Service;
            this.mainModel[this.parameterNames[2]] = [];
            this.selectedFilterItemType = this.filterItemTypes[0];
            this.initializeTypeAhead = true;
        }

        selectedTypeChanged() {
            this.initializeTypeAhead = false;
            this.selectedFilterItemType = this.filterItemTypes[
                this.mainModel[this.parameterNames[1]] === Meevo.Model.SalesTypeEnum.Service ? 0 : 1
            ];
            this.selectedList = [];
            this.mainModel[this.parameterNames[2]] = [];
            setTimeout(() => this.initializeTypeAhead = true);
        }

        selectedItemChanged() {
            if (this.selectedFilterItem) {
                this.selectedList.push(this.selectedFilterItem);
                this.mainModel[this.parameterNames[2]].push(this.selectedFilterItem['id']);
                this.selectedFilterItem = null;
            }
        }

        removeItem(itemIndex, itemId) {
            this.selectedList.splice(itemIndex, 1);
            const indexOfId = this.mainModel[this.parameterNames[2]].indexOf(itemId);
            this.mainModel[this.parameterNames[2]].splice(indexOfId, 1);
        }
    }

    angular.module('meevo.components.controls')
        .component('meevoServiceProductSelector', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/serviceProductSelector/serviceProductSelector.html',
            controller: MeevoServiceProductSelector,
            controllerAs: '$ctrl',
            bindings: {
                mainModel: '<',
                parameterNames: '<',
                securityAccess: '<',
                validationJson: '<',
                options: '<',
                disabled: '=?ngDisabled'
            }
        });
}
